import { useId, useRef } from 'react';

import { clamp, isDefined, isEmpty } from '@enterprise/core';
import { useDebounceCallback } from '@enterprise/hooks';

import type { JumpToPageProps } from '#pagination/components/types/jump-to-page.props';

import { usePaginationSelector } from '#pagination/context/hooks/selector.hook';
import { useTotalPages } from '#pagination/hooks/total-pages.hook';

export const useJumpToPageConfiguration = ({ onPageChange }: JumpToPageProps) => {
  const page = usePaginationSelector(({ page }) => {
    return page;
  });

  const inputId = useId();
  const ref = useRef<HTMLInputElement>(null);
  const totalPages = useTotalPages();

  const handleOnChange = useDebounceCallback((value: string) => {
    if (isEmpty(value)) {
      return;
    }

    const { max, min } = ref.current ?? {};

    const clamped = clamp(
      Number.parseInt(value, 10),
      Number.parseInt(min ?? '1', 10),
      Number.parseInt(max ?? totalPages.toString(), 10)
    );

    onPageChange?.(clamped);

    if (isDefined(ref.current)) {
      ref.current.select();
    }
  }, 500);

  return { handleOnChange, inputId, page, ref, totalPages };
};
